import Swiper from 'node_modules/swiper/swiper-bundle.js';

$(document).ready( function() {
    new Swiper('.swiper-container', {
        slidesPerView: 4,
        spaceBetween: 0,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            940: {
                slidesPerView: 4,
                spaceBetween: 0
            }
        }
    });
})
    
